import { view, cssGenerator } from '@yola/ws-sdk';
import stripAutofillAtBreakpoint from './strip-autofill-at-breakpoint';

const { TEXT } = cssGenerator.constants.classNames;

const getBreakpointPrefixesFromClass = (className) => [
  ...new Set(
    className
      .split(' ')
      .filter((cls) => cls.includes(':'))
      .map((cls) => cls.substring(0, cls.indexOf(':')))
  ),
];

const removeFontSizeFromNode = (node) => {
  const currentClass = node.getAttribute('class') || '';
  const breakpoint = view.accessors.getBreakpointByDeviceMode() || null;
  const hasClassAtCurrentBreakpoint = view.verifiers.hasResponsiveClass({
    element: node,
    className: TEXT,
    breakpoint,
  });

  if (hasClassAtCurrentBreakpoint) {
    const cleanedClass = view.helpers.removeResponsiveClasses({
      currentClass,
      className: TEXT,
      breakpoint,
    });
    node.setAttribute('class', cleanedClass.trim());
  }

  const classAfterBreakpointCleanup = node.getAttribute('class') || '';
  const classWithoutAutofill = stripAutofillAtBreakpoint(
    classAfterBreakpointCleanup,
    breakpoint,
    TEXT
  );

  if (classWithoutAutofill !== classAfterBreakpointCleanup) {
    node.setAttribute('class', classWithoutAutofill.trim());
  }
};

const removeAllFontSizesFromNode = (node) => {
  const currentClass = node.getAttribute('class') || '';

  const hasFontSize = view.verifiers.hasResponsiveClass({
    element: node,
    className: TEXT,
  });

  if (!hasFontSize) return;

  const breakpoints = [null, ...getBreakpointPrefixesFromClass(currentClass)];

  const cleanedClass = breakpoints.reduce(
    (result, breakpoint) =>
      view.helpers.removeResponsiveClasses({
        currentClass: result,
        className: TEXT,
        breakpoint,
      }),
    currentClass
  );

  node.setAttribute('class', cleanedClass.trim());
};

export { removeAllFontSizesFromNode };
export default removeFontSizeFromNode;
